import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7244cff4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-edit" }
const _hoisted_2 = {
  key: 0,
  class: "canvas-result-mask mask-left"
}
const _hoisted_3 = {
  key: 1,
  class: "canvas-result-mask mask-top"
}
const _hoisted_4 = {
  key: 2,
  class: "canvas-result-mask mask-right"
}
const _hoisted_5 = {
  key: 3,
  class: "canvas-result-mask mask-bottom"
}

import { ref, reactive } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEdit',
  emits: ['update'],
  setup(__props, { emit }) {

const image = reactive<any>({});
const context = reactive<any>({});
const targetContext = reactive<any>({});
const drag = reactive({
  imageOffsetX: 0,
  imageOffsetY: 0,
  deltaX: 0,
  deltaY: 0,
  startX: 0,
  startY: 0,
});
const zoom = reactive({
  factor: 1,
});

//refs
const canvas = ref<HTMLCanvasElement | null>();
const targetCanvas = ref<HTMLCanvasElement | null>();
const container = ref<HTMLElement | null>();
const input = ref<HTMLInputElement | null>();



const chooseImage = (ev: any) => {
  const file = ev.target.files[0];

  const reader = new FileReader();
  reader.readAsDataURL(file);
  if (canvas.value && targetCanvas.value) {
    Object.assign(context, canvas.value.getContext('2d'));
    Object.assign(targetContext, targetCanvas.value.getContext('2d'));

    reader.onloadend = (readerLoaded: any) => {
      Object.assign(image, new Image());
      image.src = readerLoaded.target.result;
      image.onload = () => {
        context.drawImage(image, 0, 0, image.width, image.height);
        updateTargetCanvas();
      };
    };
  }
};

const mouseDown = (ev: MouseEvent) => {
  // define start position
  drag.startX = ev.clientX;
  drag.startY = ev.clientY;
  if (container.value) {
    container.value.classList.toggle('moving');
  }
};
const mouseUp = (ev: MouseEvent) => {
  if (container.value && container.value.classList.contains('moving')) {
    // store the current offset
    drag.imageOffsetX = drag.deltaX;
    drag.imageOffsetY = drag.deltaY;
    // temp offset the image to 0 in order to copy the right rectangle
    updateTargetCanvas();
    container.value.classList.remove('moving');
  }
};
const mouseMove = (ev: MouseEvent) => {
  if (container.value && container.value.classList.contains('moving')) {
    // calculate delta from start position
    const deltaX = ev.clientX - drag.startX;
    const deltaY = ev.clientY - drag.startY;

    if (clearCanvas()) {
      // store current delta total
      drag.deltaX = Math.max(
        Math.min(drag.imageOffsetX + deltaX, 0),
        -image.width + 400,
      );
      drag.deltaY = Math.max(
        Math.min(drag.imageOffsetY + deltaY, 0),
        -image.height + 280,
      );
      // redraw the image with the offset
      updateCanvas();
    }
  }
};
const clearCanvas = () => {
  if (context && canvas.value) {
    context.clearRect(0, 0, canvas.value.width, canvas.value.height);
    return true;
  }
  return false;
};
const updateCanvas = (offsetX = 0, offsetY = 0) => {
  context.drawImage(
    image,
    drag.deltaX + offsetX,
    drag.deltaY + offsetY,
    image.width + zoom.factor,
    image.height + zoom.factor,
  );
};
const updateTargetCanvas = () => {
  updateCanvas(-20, -70);
  if (targetContext) {
    targetContext.drawImage(canvas, 0, 0);
  }
  updateCanvas();
  emit('update', (targetCanvas.value as HTMLCanvasElement).toDataURL());
};

const onScroll = (ev: MouseEvent) => {
  return;

  // use ratio of current offset to image size and mouse offset to calculate how much to move the offset relative
  // zooming and dragging are not related to each other
  // ev.preventDefault();
  // if (this.image) {
  //   this.clearCanvas();
  //   this.zoom.factor = this.zoom.factor + event.deltaY * 0.001;
  //   this.context.drawImage(
  //     this.image,
  //     drag.imageOffsetX,
  //     drag.imageOffsetY,
  //     this.image.width * this.zoom.factor,
  //     this.image.height * this.zoom.factor,
  //   );
  // }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("input", {
      type: "file",
      ref_key: "input",
      ref: input,
      autofocus: "",
      onChange: chooseImage,
      autocomplete: "off"
    }, null, 544),
    _createElementVNode("div", {
      ref_key: "container",
      ref: container,
      class: _normalizeClass(["canvas-container", { 'has-image': image }])
    }, [
      _createElementVNode("canvas", {
        ref_key: "canvas",
        ref: canvas,
        class: "canvas canvas-preview",
        width: "400",
        height: "280",
        onWheel: onScroll,
        onMousedown: mouseDown,
        onMouseup: mouseUp,
        onMouseleave: mouseUp,
        onMousemove: mouseMove
      }, null, 544),
      image
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      image
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      image
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("", true),
      image
        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("canvas", {
        ref_key: "targetCanvas",
        ref: targetCanvas,
        class: "canvas canvas-result",
        width: "400",
        height: "140"
      }, null, 512)
    ], 2)
  ]))
}
}

})